import {GiiReport} from '../enums/reports-enum';


export const RegistrationReportsEnum = {
  REGISTRACIJOS_DUOMENU_ATASKAITA: new GiiReport(3, 'report.registracijos.ataskaita')
} as const;

export type ReportsEnumKeys = keyof typeof RegistrationReportsEnum;

export const registrationReportsList: GiiReport[] = Object.keys(RegistrationReportsEnum)
  .filter(key => isNaN(Number(key)))
  .map(key => RegistrationReportsEnum[key as ReportsEnumKeys]);
